import React from "react";
import { motion } from "framer-motion";

export default function NewCricBuddyPortfolioUserSideFeatures() {
  const data = [
    {
      img: "/Screen1.png",
      imgMobile: "/Screen1Mobile.png",
      text: "Effortless venue and date/time selection, discounts, and digital payments.",
    },
    {
      img: "/Screen2.png",
      imgMobile: "/Screen2Mobile.png",
      text: "Recurring bookings, instant cancellation/rescheduling, and playtime reminders.",
    },
    {
      img: "/Screen3.png",
      imgMobile: "/Screen3Mobile.png",
      text: "Proximity and sports-based venue search, reviews/ratings, and WhatsApp booking updates.",
    },
    {
      img: "/Screen4.png",
      imgMobile: "/Screen4Mobile.png",
      text: "Account management with booking history and OTP login for seamless experience.",
    },
  ];

  return (
    <div className="horizontal-padding pb-5">
      <div className="row">
        <div className="col-12 text-center">
          <h2 className="cb-cr-heading mb-4">User Side Features</h2>
        </div>
      </div>

      {data.map((item, index) => (
        <div className="row mb-4" key={index}>
          <div className="col-12 d-flex justify-content-center">
            <motion.div
              className="cb-user-side-card"
              initial={{ opacity: 0, y: 150 }} // 👈 from bottom
              whileInView={{ opacity: 1, y: 0 }} // 👈 to position
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
            >
              <div className="cb-user-side-img-wrapper">
                <picture>
                  <source
                    media="(max-width: 768px)"
                    srcSet={`/images/CB/${item.imgMobile}`}
                  />
                  <img
                    src={`/images/CB/${item.img}`}
                    alt="Feature"
                    className="cb-user-side-img img-fluid"
                  />
                </picture>

                <div
                  className={`cb-user-side-text ${
                    index % 2 === 0 ? "cb-left-54" : "cb-left-47"
                  }`}
                >
                  {item.text}
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      ))}
    </div>
  );
}
